import { Avatar, Group, Text, UnstyledButton } from "@mantine/core";
import { forwardRef } from "react";

interface UserButtonProps extends React.ComponentPropsWithoutRef<"button"> {
  image?: string;
  name: string;
  role: string;
}

const UserButton = forwardRef<HTMLButtonElement, UserButtonProps>(
  ({ image, name, role, ...others }: UserButtonProps, ref) => (
    <UnstyledButton ref={ref} {...others} className="hover:bg-inherit">
      <Group justify="flex-end">
        <div style={{ flex: 1 }}>
          <Text size="sm" fw={500}>
            {name}
          </Text>

          <Text c="dimmed" size="xs" ta="right">
            {role}
          </Text>
        </div>
        <Avatar src={image} radius="xl" />
      </Group>
    </UnstyledButton>
  ),
);

UserButton.displayName = "UserButton";

export default UserButton;
